export const storeTourTypes = (state, tourTypes) => {
  state.tourTypes = [...tourTypes];
};
